import check from "@/../../library/helper/propertyCheck";
import {
    colors
} from "vuetify/lib";

// Get the Color Library
import {
    buttonColor
} from "@/../../library/constants/colors.js"
import {
    getIcon
} from "@/../../library/constants/icons.js"


export function fieldStyles(field, isRequired, isRo) {
    // Field Styling
    const basic = {
        label: true
    };
    const readOnly = {
        label: true,
        disabled: true
    };
    const singleSelect = {
        multiple: false,
        label: true,
        chips: false
    };
    const textField = {
        label: true,
        clear: true,
        grow: true
    };
    const switchField = {
        flat: true
    };

    const multiSelect = {
        multiple: true,
        label: true,
        chips: true
    }


    // Compute the processing flags
    let required = !check.isUndefined(isRequired) && isRequired
    let readonly = !check.isUndefined(isRo) && isRo

    // Figure out base format of the field
    let format = {}
    if (field === "string") format = {
        ...basic
    }
    if (readonly) format = {
        ...readOnly
    }
    if (field === "list") format = {
        ...singleSelect
    }
    if (field === "textarea") format = {
        ...textField
    }
    if (field === "status") format = {
        ...switchField
    }
    if (field === "multiselect") format = {
        ... multiSelect
    }

    // Check if the field is required
    if (required) {
        format["hint"] = "*Required field"
        format["persistent_hint"] = true
        format["filled"] = true
    }
    return format
}

export function buttonStyle(name) {
    let config = {
        text: true,
        round: true,
        color: buttonColor(name)
    }
    let icon = getIcon(name)
    let obj = {
        name: name,
        config: config,
        icon: icon,
        label: name
    }
    return obj
}

export function fullSize() {
    let size = "vertical-align:top;width:100vh;"
    return size
}

export function card800() {
    let size = "width:800px; vertical-align:top;"
    return size
}